import React, { useState } from 'react';
import { BotAjustesModal } from './BotAjustesModal';

/**
 * Engrane discreto junto al switch del bot de ventas (bandeja cotizaciones).
 * Abre el modal "Ajustes del bot". El modal solo se monta mientras está abierto.
 */
export const BotAjustesEngrane = () => {
  const [abierto, setAbierto] = useState(false);
  return (
    <>
      <button
        type="button"
        aria-label="Ajustes del bot"
        title="Ajustes del bot"
        onClick={() => setAbierto(true)}
        style={{
          width: 24, height: 24, borderRadius: 7, border: '1px solid #E7EBF0', background: '#fff',
          color: '#64748B', cursor: 'pointer', display: 'inline-flex', alignItems: 'center',
          justifyContent: 'center', flexShrink: 0, padding: 0,
        }}
      >
        <span className="pi pi-cog" style={{ fontSize: 12 }} />
      </button>
      {abierto && <BotAjustesModal onClose={() => setAbierto(false)} />}
    </>
  );
};

export default BotAjustesEngrane;
